module.exports = __webpack_public_path__ + "media/images/img_map_tokyo-a8864638f57d267e611e10a3659bbd24.png";